import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { EquipmentsTypesApi } from 'app/main/settings/registers/equipments-types/services/api/equipments-types-api.service';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return EquipmentsTypeComponent; }),
    multi: true
};
var EquipmentsTypeComponent = /** @class */ (function () {
    function EquipmentsTypeComponent(fuseTranslationLoaderService, equipmentsTypesApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsTypesApi = equipmentsTypesApi;
        this.disabled = false;
        this.appearance = 'outline';
        this.equipmentsType = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    EquipmentsTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.required) {
            this.inputValue.setValidators(Validators.required);
        }
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges
            .pipe(debounceTime(500))
            .subscribe(function (searchTerm) {
            _this.equipmentsType = [];
            if (searchTerm) {
                _this.searchEquipmentsTypes(searchTerm);
            }
        });
    };
    EquipmentsTypeComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    EquipmentsTypeComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    EquipmentsTypeComponent.prototype.searchEquipmentsTypes = function (searchTerm) {
        var _this = this;
        this.loading = true;
        var options = {
            where: {
                name_contains: searchTerm,
                archived: false
            },
            orderBy: 'name_asc',
            limit: 10,
            offset: 0
        };
        this.equipmentsTypesApi
            .listEquipmentsTypes(options)
            .subscribe(function (result) {
            _this.equipmentsType = result.items;
            _this.loading = false;
        });
    };
    EquipmentsTypeComponent.prototype.writeValue = function (equipmentType) {
        var _this = this;
        if (!equipmentType || !equipmentType.id) {
            return this.deselectEquipmentType();
        }
        this.equipmentsTypesApi
            .getEquipmentTypeById(equipmentType.id)
            .subscribe(function (result) {
            _this.selectedEquipmentType = result;
            _this.inputValue.setErrors(null);
        });
    };
    EquipmentsTypeComponent.prototype.setSelectedEquipmentType = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedEquipmentType = this.equipmentsType.find(function (equipmentType) {
                return equipmentType.id === _this.inputValue.value;
            });
            this.onChange(this.selectedEquipmentType);
            this.inputValue.setErrors(null);
        }
    };
    EquipmentsTypeComponent.prototype.deselectEquipmentType = function () {
        this.onChange(null);
        this.selectedEquipmentType = null;
        this.inputValue.setValue(null);
        this.inputValue.setErrors(null);
    };
    return EquipmentsTypeComponent;
}());
export { EquipmentsTypeComponent };
